module.exports = __webpack_public_path__ + "static/media/duplicate.675cae3e.svg";